import escape from 'lodash.escape'

export default function (term, data) {
  var creatable = term && data.creatable(term)

  if (creatable) {
    var c = {}

    c[data.accessors.label] = typeof creatable[data.accessors.label] !== 'undefined' ? creatable[data.accessors.label] : escape(term)
    c[data.accessors.value] = typeof creatable[data.accessors.value] !== 'undefined' ? creatable[data.accessors.value] : term

    if (creatable.dataset) {
      c.dataset = creatable.dataset
    }

    if (creatable.className) {
      c.clazz = creatable.className
    }
    c.creatable = true
    return c
  } else {
    return null
  }
}
